import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, flatMap, map } from 'rxjs/operators';
import {
  ActionsEnum,
  ExportData,
  ExportDataError,
  exportDataError,
  ExportDataSuccess,
  exportDataSuccess,
  ExportExpenseReportData,
  ExportExpenseReportDataError,
  exportExpenseReportDataError,
  ExportExpenseReportDataSuccess,
  exportExpenseReportDataSuccess,
} from './export-data.actions';
import { ExportDataService } from './export-data.service';

@Injectable()
export class ExportDataEffects {
  constructor(
    private _actions: Actions,
    private _exportDataService: ExportDataService
  ) {}

  @Effect()
  exportData: Observable<
    ExportDataSuccess | ExportDataError
  > = this._actions.pipe(
    ofType(ActionsEnum.EXPORT_DATA),
    flatMap(({ payload }: ExportData) => {
      const { dispatchId, exportType, userEmail, companyName } = payload;

      return this._exportDataService
        .exportData(exportType, userEmail, companyName)
        .pipe(
          map(() => exportDataSuccess(dispatchId)),
          catchError(() => of(exportDataError(dispatchId)))
        );
    })
  );

  @Effect()
  exportExpenseReportData: Observable<
    ExportExpenseReportDataSuccess | ExportExpenseReportDataError
  > = this._actions.pipe(
    ofType(ActionsEnum.EXPORT_EXPENSE_REPORT_DATA),
    flatMap(({ payload }: ExportExpenseReportData) => {
      const { dispatchId, userEmail, taxYear } = payload;

      return this._exportDataService
        .exportExpenseReport(userEmail, taxYear)
        .pipe(
          map(() => exportExpenseReportDataSuccess(dispatchId)),
          catchError(() => of(exportExpenseReportDataError(dispatchId)))
        );
    })
  );
}
